import { Network } from "@capacitor/network";
import { useEffect, useState } from "react";

export default function useNetworkStatus() {
	const [status, setStatus] = useState(null);

	useEffect(() => {
		const fetchStatus = async () => {
			setStatus(await Network.getStatus());
		};

		fetchStatus();
	}, []);

	Network.addListener("networkStatusChange", (status) => {
		setStatus(status);
	});

	return status;
}
